import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';

const sarahwellsbagsSizeOptions = ['XXS/XS', 'S', 'S/M', 'M', 'L', 'L/XL', 'XL', '2XL/3XL'];

const sarawellsbagsConditionOptions = [
  {
    key: Conditions.NewWithoutTags,
    label: 'New, Never Used',
    description: 'Your item has never been used. There are no quirks or issues whatsoever.',
  },
  {
    key: Conditions.Excellent,
    label: 'Excellent Condition',
    description:
      'Your item has only been lightly used and has been extremely well maintained. There may be some small signs of wear, but nothing major.',
  },
  {
    key: Conditions.Good,
    label: 'Well Loved',
    description:
      'You’ve used this item and it’s well maintained. There may be some quirks like a small stain, or a loose thread, but it’s overall in good shape. You will need to take pictures of any quirks the item has.',
  },
];

export const sarahwellsbagsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: sarawellsbagsConditionOptions }),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: sarahwellsbagsSizeOptions }),
  ],
};
